import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { USER_LOGIN } from '../endPoints';
import { baseURL } from '../baseUrl/baseURL';

export const authAPI = createApi({
    reducerPath: 'authAPI',
    baseQuery: fetchBaseQuery({ baseUrl: baseURL}),
    endpoints: (builder) => ({
        login: builder.mutation({
            query: (payload) => ({
                url: `${USER_LOGIN}`,
                method: 'POST',
                body: payload,
            }),
        }),
        logout: builder.mutation({
            query: (payload) => ({
                url: ``,
                method: ``,
                body: payload,
            }),
        }),
    }),
});

export const { useLoginMutation, useLogoutMutation } = authAPI;
